export const PERSONAL_DATA_MESSAGE_CODES = {
	genericError: "E_GENERIC_ERROR",
	requestAlreadyExist: "E_VALIDATION_SUBJECTACCESSREQUEST_REQUESTALREADYEXISTS",
	invalidDataSet: "E_VALIDATION_SUBJECTACCESSREQUEST_INVALIDDATASET",
	invalidRequestId: "E_VALIDATION_SUBJECTACCESSREQUEST_INVALIDREQUESTID",
	requestNotFound: "E_VALIDATION_SUBJECTACCESSREQUEST_REQUESTWASNOTFOUND",
	requestDataSetsSuccess: "E_REQUESTDATASETS_SUCCESS",
};
